
export function imgFormat(str) {
    return (process.env.NODE_ENV == 'development' ? 'http://localhost:8888' : '') + '/uploads/imgs/' + str;
  }